import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Contrat / parchemin — distinct de DocumentsIcon (générique).
 * Représente un acte juridique : parchemin enroulé en haut et en bas.
 */
export const ContractIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Corps du parchemin (aplat menthe atténué) */}
      <path
        d="M6 5h11v14H6c-1 0-2-1-2-2.5S5 14 6 14s2 1 2 2.5"
        fill="var(--equiply-icon-bg)" fillOpacity="0.45"
      />
      {/* Bord roulé en haut */}
      <path
        d="M6 5h11c1.5 0 2.5 1 2.5 2.5S18.5 10 17 10"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Corps */}
      <path
        d="M17 10v9H8"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Bord roulé en bas */}
      <path
        d="M8 19c-2.2 0-4-1.1-4-2.5S5 14 6 14s2 1 2 2.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Lignes texte */}
      <path d="M9 9h6M9 12h5M9 15h6" stroke="var(--equiply-icon-fg)" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  ),
);
ContractIcon.displayName = "ContractIcon";
